import { render, staticRenderFns } from "./AutoOffShelfTimeField.vue?vue&type=template&id=ca1d2836"
import script from "./AutoOffShelfTimeField.vue?vue&type=script&lang=ts"
export * from "./AutoOffShelfTimeField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports